// removed by extract-text-webpack-plugin
module.exports = {"errorPage":"ErrorPage__errorPage___N2Vff","logo":"ErrorPage__logo___1MJhF"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/ErrorPage/ErrorPage.scss
// module id = 734
// module chunks = 0